exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-item[data-v-3dd2e005] {\n  overflow: auto;\n  height: calc(100vh - 180px);\n}\n.cartItemCount[data-v-3dd2e005] {\n  border-radius: 50%;\n  font-size: 12px;\n  /* font-weight: bold; */\n}\n.input-data[data-v-3dd2e005] {\n  width: 80%;\n  height: 36px;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #000000;\n}\n.search[data-v-3dd2e005] {\n  width: 20%;\n  height: 36px;\n  /* border-radius: 2px; */\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #000000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3dd2e005","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home/Home.vue
// module id = 413
// module chunks = 1